module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dcd4e99c8ddf7634ce04803950b7e266.png";